<template>
  <div>
    <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
      :color="color"
    />
    <Header2 />

    <div class="rg-c">
      <div class="gc-x">
        <h2 class="hc-x">Transactions</h2>

        <!-- Filters -->
        <div class="filter-container">
          <div class="filter-card">
            <label>From</label>
            <input type="date" v-model="fromDate" @change="applyFilters" />
          </div>
          <div class="filter-card">
            <label>To</label>
            <input type="date" v-model="toDate" @change="applyFilters" />
          </div>
          <div class="filter-card search-card">
            <label>Search </label>
            <input
              type="search"
              v-model.trim="search"
              @input="applyFilters"
              placeholder="Search transaction"
            />
          </div>
        </div>

        <!-- Transactions Table -->
        <div v-if="paginatedTransactions.length > 0" class="table-responsive">
          <table class="transaction-table">
            <thead>
              <tr>
                <th>Ref</th>
                <th>Network</th>
                <th>Plan</th>
                <th>Receiver</th>
                <th>Amount</th>
                <th>B/Before</th>
                <th>B/After</th>

                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in paginatedTransactions"
                :key="item.ref"
                @click="
                  getEachTransaction(
                    item.ref,
                    item.status,
                    item.amount,
                    item.network,
                    item.updated_at,
                    item.reciever,
                    item.name,
                    item.user,
                    item.type,
                    item.commission,
                    item.plan,
                    item.eletoken
                  )
                "
                class="table-row"
              >
                <td>{{ item.ref }}</td>
                <td>
                  <img
                    v-if="item.network == '1'"
                    src="../../assets/image/mtn-data.png"
                    class="net-icon"
                  />
                  <img
                    v-else-if="item.network == '2' || item.network == 'Airtel'"
                    src="../../assets/image/airtel-data.png"
                    class="net-icon"
                  />
                  <img
                    v-else-if="item.network == '3'"
                    src="../../assets/image/etisalat-data.png"
                    class="net-icon"
                  />
                  <img
                    v-else-if="item.network == '4'"
                    src="../../assets/image/glo-logo.jpg"
                    class="net-icon"
                  />
                  <img v-else src="../../assets/image/received.png" class="net-icon" />
                  <span>{{
                    item.network === "1"
                      ? "MTN"
                      : item.network === "2"
                      ? "Airtel"
                      : item.network === "3"
                      ? "9Mobile"
                      : "GLO"
                  }}</span>
                </td>
                <td style="display: flex">
                  <span v-if="item.plan">{{ item.plan }}</span> &nbsp;
                </td>
                <td>
                  <span v-if="item.reciever">{{ item.reciever }}</span>
                </td>
                <td>₦{{ Intl.NumberFormat().format(item.amount) }}</td>
                <td>₦{{ Intl.NumberFormat().format(item.bbefore) }}</td>
                <td>₦{{ Intl.NumberFormat().format(item.bafter) }}</td>

                <td>
                  <span
                    :class="{
                      'status-success': isSuccessDisplay(item),
                      'status-failed': !isSuccessDisplay(item) && item.status != 1,
                    }"
                  >
                    {{
                      isSuccessDisplay(item)
                        ? "Success"
                        : item.status == 1 && item.type == "4" && item.network != userId
                        ? "Sent"
                        : item.status == 1 && item.type == "4" && item.network == userId
                        ? "Received"
                        : "Failed"
                    }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ new Date(item.updated_at).toLocaleDateString() }}
                    {{
                      new Date(item.updated_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="empty-state">No Transaction</div>

        <!-- Pagination -->
        <div class="pagination-control" v-if="totalPages > 1">
          <button :disabled="currentPage === 1" @click="prevPage">Prev</button>
          <span
            v-for="page in totalPages"
            :key="page"
            :class="{ 'active-page': currentPage === page }"
            @click="goToPage(page)"
          >
            {{ page }}
          </span>
          <button :disabled="currentPage === totalPages" @click="nextPage">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header2 from "../../components/header.vue";
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "DataTransactionPage",
  components: { Header2, Loading },
  data() {
    return {
      token: "",
      userId: "",

      selected: "Transaction",
      isLoading: true,
      fullPage: true,
      color: "#0A1AA8",

      transactions: [],
      schedules: [],

      fromDate: "",
      toDate: "",
      searchRef: "",
      search: "",
      totalMainPages: 0,

      currentPage: 1,
      perPage: 50,

      moment,
    };
  },
  computed: {
    filteredTransactions() {
      let list = Array.isArray(this.transactions) ? this.transactions.slice() : [];
      if (this.searchRef.trim() !== "") {
        const q = this.searchRef.trim().toLowerCase();
        list = list.filter((it) =>
          String(it.ref || "")
            .toLowerCase()
            .includes(q)
        );
      }
      console.log(list);
      return list;
    },

    paginatedTransactions() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredTransactions.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.totalMainPages / this.perPage);
    },
    filteredSchedules() {
      let list = Array.isArray(this.schedules) ? this.schedules.slice() : [];
      if (this.searchRef.trim() !== "") {
        const q = this.searchRef.trim().toLowerCase();
        list = list.filter((it) =>
          String(it.ref || it.reference || "")
            .toLowerCase()
            .includes(q)
        );
      }
      return list;
    },
  },
  watch: {
    fromDate: "fetchTransactions",
    toDate: "fetchTransactions",
    search: "fetchTransactions",
    //searchRef: "fetchTransactions",
    searchRef() {
      this.currentPage = 1; // reset page on new search
    },
  },
  methods: {
    setSelected(tab) {
      this.selected = tab;
    },
    applyFilters() {},
    isSuccessDisplay(item) {
      const s = item.status;
      const t = item.type;
      return (
        s == 1 &&
        (["3", "2", "5", "8", "6", "10"].includes(String(t)) ||
          (String(t) == "1" && s == 1))
      );
    },
    getEachTransaction(
      ref,
      status,
      amount,
      network,
      date,
      reciever,
      name,
      user,
      type,
      commission,
      plan,
      token
    ) {
      const data = {
        ref,
        status,
        amount,
        network,
        date,
        receiver: reciever,
        name,
        user,
        type,
        commission,
        plan,
        token,
      };
      localStorage.setItem("data", JSON.stringify(data));
      this.$router.push(`/user/transaction-details/${ref}`);
    },
    getEachSchedules(
      ref,
      status,
      amount,
      network,
      date,
      reciever,
      end,
      start,
      time,
      fr,
      plan
    ) {
      const datas = {
        ref,
        status,
        amount,
        network,
        date,
        receiver: reciever,
        end,
        start,
        time,
        occurence: fr,
        plan,
      };
      localStorage.setItem("datas", JSON.stringify(datas));
      this.$router.push(`/user/schedules-details`);
    },
    async fetchTransactions() {
      if (!this.token) return;

      this.isLoading = true;
      const from_date = moment(this.fromDate).format("YYYY-MM-DD");
      const to_date = moment(this.toDate).format("YYYY-MM-DD");
      const search = this.search;
      const count = this.perPage;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}api/gettransaction`,
          {
            headers: { Authorization: "Bearer " + this.token },
            params: { from_date, to_date, search, count },
          }
        );

        //  console.log(response);
        this.transactions = Array.isArray(response.data.data?.data)
          ? response.data.data?.data
          : [];
        this.currentPage = 1;

        this.totalMainPages = response?.data?.data?.total; // reset page after fetch
      } catch (e) {
        if (e?.response?.status === 401) {
          this.$router.push("/panel/login");
          localStorage.removeItem("user");
        } else console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
  async mounted() {
    const today = moment();
    this.toDate = today.format("YYYY-MM-DD");
    this.fromDate = today.startOf("month").format("YYYY-MM-DD");

    try {
      const data = JSON.parse(localStorage.getItem("user"));
      this.token = data.data.token;
      this.userId = data.data.data.id;
    } catch (e) {
      this.token = "";
      this.userId = "";
    }

    await this.fetchTransactions();

    try {
      const schedule = await axios.get(
        `${process.env.VUE_APP_BASE_URL}api/getscheadule`,
        {
          headers: { Authorization: "Bearer " + this.token },
        }
      );
      this.schedules = Array.isArray(schedule.data.data)
        ? schedule.data.data.reverse()
        : [];
    } catch (e) {
      if (e?.response?.status === 401) {
        this.$router.push("/panel/login");
        localStorage.removeItem("user");
      } else console.error(e);
    }
  },
};
</script>
<style scoped>
/* Reused/design-consistent styles (compact filter + list) */
.rg-c {
  font-family: "Quicksand", Georgia, "Times New Roman", Times, serif;
  font-size: 1.6rem;
  padding: 10px;
}
.gc-x {
  margin: 100px auto;
  width: 100%;

  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  padding: 20px;
  border-radius: 15px;
} /* title */
.hc-x {
  font-size: 1.4rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 12px;
} /* FILTER BAR */
.filter-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  align-items: center;
}
.filter-card {
  background: #f4f6fb;
  padding: 8px 12px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  min-width: 140px;
}
.filter-card label {
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 6px;
}
.filter-card input[type="date"],
.filter-card input[type="search"] {
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #d6d9e6;
  outline: none;
  font-size: 0.9rem;
} /* search card stretches */
.search-card {
  flex: 1;
  min-width: 220px;
} /* export actions */
.export-actions {
  display: flex;
  gap: 8px;
}
button {
  background: #0a1aa8;
  color: #fff;
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 700;
}
button:hover {
  opacity: 0.95;
} /* main list area */
.ech-transt-info-col {
  background: #fff;
  margin-top: 10px;
} /* item */
.md-lb-info {
  padding: 10px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
}
.md-lb-info:hover {
  background: #fbfcff;
} /* network icon */
.net-icon {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  margin-right: 12px;
  border-radius: 100%;
  object-fit: cover;
} /* placeholder icon */
.icon-placeholder {
  width: 40px;
  height: 40px;
  border: 1px solid #ddd;
  margin-right: 12px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
} /* right side grid */
.right-inf-sid {
  width: 100%;
  display: grid;
  gap: 6px;
} /* top row */
.dwn-tpg {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-left {
  font-weight: 700;
  font-size: 0.92rem;
  color: #111;
}
table-responsive {
  overflow-x: hidden;
  margin-top: 15px;
}

.transaction-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.transaction-table th,
.transaction-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.transaction-table th {
  background: #f4f6fb;
  font-weight: 700;
}

.table-row:hover {
  background: #fbfcff;
  cursor: pointer;
}

.net-icon {
  width: 24px;
  height: 24px;
  margin-right: 6px;
  vertical-align: middle;
}
.amount-right {
  font-weight: 800;
  color: #0a1aa8;
  font-size: 16px;
} /* meta row */
.meta-row .status-text {
  font-weight: 700;
}
.meta-row .time-text {
  color: #666;
  font-size: 0.85rem;
} /* status colors */
.status-success {
  color: green;
  font-weight: 700;
  font-size: 16px;
}
.status-failed {
  color: crimson;
  font-weight: 700;
  font-size: 16px;
} /* empty */
.empty-state {
  text-align: center;
  font-weight: 700;
  font-size: 0.95rem;
  margin-top: 20px;
  padding: 30px 0;
  color: #666;
} /* responsive */
@media screen and (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    gap: 10px;
  }
  .filter-card {
    width: 100%;
    min-width: auto;
  }
  .gc-x {
    margin: 60px 10px;
    padding: 15px;
  }
  .md-lb-info {
    padding: 12px;
    gap: 10px;
  }
}
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin: 20px 0;
  font-size: 16px;
  flex-wrap: wrap;
  font-family: "Quicksand", sans-serif;
}

.pagination-controls button {
  background: #0a1aa8;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background 0.2s, transform 0.1s;
}

.pagination-controls button:hover:not(:disabled) {
  background: #06137b;
  transform: scale(1.05);
}

.pagination-controls button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.pagination-controls .active-page {
  background: #06137b;
  color: #fff;
  font-weight: 700;
}

.pagination-control span {
  padding: 6px 10px;
  font-weight: 600;
  color: #555;
}
</style>
